import axios, { AxiosStatic } from 'axios';

const getAuthSession = (): string | null => {
  const item = sessionStorage.getItem('token');
  if (item) {
    return item;
  } else {
    return null;
  }
};

const getBearerToken = () => {
  const token = getAuthSession();
  if (token !== null) {
    return token;
  } else {
    return null;
  }
};

/**
 * @description This is middleware to inject the users token into all api requests if they exist
 */
export class BaseAPI {
  constructor() {
    BaseAPI.axios = this.configureAxiosInterceptors();
  }
  public static axios: AxiosStatic;

  private configureAxiosInterceptors = () => {
    axios.interceptors.request.use((request) => {
      const Bearer = getBearerToken();
      if (Bearer !== null) {
        request.headers['Authorization'] = `Bearer ${Bearer}`;
      }
      return request;
    });

    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        switch (error?.response?.status) {
          case 401:
            return Promise.reject(new Error('User not authorized'));
          default:
            return Promise.reject(error);
        }
      }
    );
    return axios;
  };
}
